import { spacing, styled, Text } from '@thg-commerce/enterprise-theme'
import { ProductSummaryOrder } from '@thg-commerce/enterprise-pages/src/Product/theme'

export const ExternalIdentifierDisplayContainer = styled.div<{
  order?: ProductSummaryOrder
}>`
  order: ${(props) => props.order || ProductSummaryOrder.FOUR};
  ${Text('small', 'default')};
  padding: ${spacing(1)} 0;
`
